<template>
  <section v-editable="blok" feature-cards :data-spacing="blok?.spacing || 'default'" :data-style="blok?.style || 'default'" :data-columns="blok?.columns || 3" :data-no-max-width="blok?.disableCardsMaxWidth ?? false">
    <div class="container">
      <div class="row section-header">
        <div class="section-left">
          <h2 v-if="hasRichTextContent(blok?.title)" class="section-title">
            <StoryblokRichText :resolvers="richtextResolvers" :doc="blok.title" />
          </h2>
        </div>
        <div class="section-right">
          <div v-if="hasRichTextContent(blok?.description)" class="section-description">
            <StoryblokRichText :resolvers="richtextResolvers" :doc="blok.description" />
          </div>
        </div>
        <div v-if="['default', 'columns'].includes(blok.style || 'default') && blok?.buttons && blok?.buttons?.length > 0" class="row row-footer">
          <div class="section-buttons">
            <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
          </div>
        </div>
      </div>
      <div v-if="blok?.cards && blok?.cards?.length > 0" class="row">
        <div class="section-cards">
          <StoryblokComponent v-for="card in blok.cards" :key="card._uid" :blok="card" />
        </div>
      </div>
      <div v-if="blok?.logos && blok?.logos?.length > 0" class="row">
        <div class="section-logos">
          <NuxtImg v-for="(logo, s) in blok.logos" :key="s" v-editable="logo" provider="storyblok" :src="logo.filename" :alt="`Partner ${logo.filename.replace('/img/', '').replace('-logo.svg', '')}`" v-bind="dimensions(logo)" />
        </div>
      </div>
      <div v-if="['footer-cta'].includes(blok.style || 'default')" class="row row-footer">
        <div v-if="blok.buttons && blok?.buttons?.length > 0" class="section-buttons">
          <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
        </div>
        <div v-if="hasRichTextContent(blok.footer_text)" class="section-footer">
          <StoryblokRichText :resolvers="richtextResolvers" :doc="blok.footer_text" />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import type { AssetStoryblok, FeatureCardsStoryblok } from "~/types/storyblok";
  import { richtextResolvers, hasRichTextContent } from "#imports";

  defineProps<{
    blok: FeatureCardsStoryblok;
  }>();

  const dimensions = (image: AssetStoryblok) => {
    if (image) {
      const urls = image?.filename?.split("/")[5].split("x");

      if (urls?.length !== 2) return { width: 0, height: 0 };

      return {
        width: urls[0],
        height: urls[1],
      };
    }
    return { width: 0, height: 0 };
  };
</script>
<style src="~/assets/scss/section/feature-cards.scss" lang="scss"></style>
